import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TitleInsuranceQuote } from '@models/title-insurance';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { TestHooks } from './fct-footer.hooks';

@Component({
	selector: 'app-fct-footer',
	templateUrl: './fct-footer.component.html',
	standalone: false,
})
export class FctFooterComponent {
	testHooks = TestHooks;
	@Input() allowCancel = true;
	@Output() openModal: EventEmitter<void> = new EventEmitter();
	@Output() cancelOrder: EventEmitter<void> = new EventEmitter();

	@Select(SelectedMatter.titleInsuranceQuote)
	quote$: Observable<TitleInsuranceQuote>;

	cancel(): void {
		this.cancelOrder.emit();
	}

	getQuote(): void {
		this.openModal.emit();
	}
}
